/**
 * @description 職業類別用(會員註冊 setp2 、保單檢核)
 */
export enum OccupationIdType {
  /** 一般職業 */
  Normal = '0',
  /** 非一般職業 */
  Special = '1',
  /** 保單檢核職業類別-一般 */
  RuleCheckNormal = '1',
  /** 保單檢核職業類別-特殊 */
  RuleCheckSpecial= '2'
}
